/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} ResellersInputs */

const en_resellers = /** @type {(inputs: ResellersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resellers`)
};

const th_resellers = /** @type {(inputs: ResellersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ตัวแทนจำหน่าย`)
};

const ja_resellers = /** @type {(inputs: ResellersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`販売店`)
};

const fr_resellers = /** @type {(inputs: ResellersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revendeurs`)
};

const es_resellers = /** @type {(inputs: ResellersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Distribuidores`)
};

const ru_resellers = /** @type {(inputs: ResellersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Магазины`)
};

const zh_resellers = /** @type {(inputs: ResellersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`经销商`)
};

const vi_resellers = /** @type {(inputs: ResellersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đại lý`)
};

/**
* | output |
* | --- |
* | "Resellers" |
*
* @param {ResellersInputs} inputs
* @param {{ locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }} options
* @returns {LocalizedString}
*/
export const resellers = /** @type {((inputs?: ResellersInputs, options?: { locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<ResellersInputs, { locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_resellers(inputs)
	if (locale === "ja") return ja_resellers(inputs)
	if (locale === "fr") return fr_resellers(inputs)
	if (locale === "es") return es_resellers(inputs)
	if (locale === "ru") return ru_resellers(inputs)
	if (locale === "zh") return zh_resellers(inputs)
	if (locale === "vi") return vi_resellers(inputs)
	return en_resellers(inputs)
});